__turbopack_context__.v({
  "action-button-flex": "styles-module__sXmaRW__action-button-flex",
  "action-button-wrapper": "styles-module__sXmaRW__action-button-wrapper",
  "column-wrapper": "styles-module__sXmaRW__column-wrapper",
  "desktop-left": "styles-module__sXmaRW__desktop-left",
  "desktop-right": "styles-module__sXmaRW__desktop-right",
  "totaliser-buttons-flex": "styles-module__sXmaRW__totaliser-buttons-flex",
});
